import 'css-chunk:src/components/Button/Button.module.scss';export default {
  "Button": "Button-module__Button___0OJEu"
};